import { useFreedomPayment } from './model';

export const freedomPayment = {
  model: { useFreedomPayment },
};
